import './assets/app.css';

import { registerServiceWorker } from '@/services/serviceWorker';
import { createSentryPiniaPlugin } from '@sentry/vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import { createApp } from 'vue';
import App from './App.vue';
import FontAwesomeIcon from './fontawesome-icons';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { configurePrimeVue } from './primevueConfig';
import router from './router';
import { configureSentry } from './sentryConfig';

dayjs.extend(localizedFormat);
dayjs.locale(window.navigator.language || 'en-us');

const app = createApp(App)

app.use(ToastService);
configurePrimeVue(app);
configureSentry(app);

app.use(router)
const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.directive('ripple', Ripple);
app.directive('tooltip', Tooltip);
app.component('font-awesome-icon', FontAwesomeIcon);

app.mount('#app')

registerServiceWorker();